import { lazy, Suspense, useState } from "react";
import { ConsultaIndividual } from "./componentes/ConsultaIndividual.js";

// A aba de planilha carrega a biblioteca de leitura de XLSX, que é grande.
// Adiá-la mantém leve a consulta individual, que é o uso mais comum.
const Planilha = lazy(async () => ({ default: (await import("./componentes/Planilha.js")).Planilha }));

const ABAS = [
  { id: "individual", rotulo: "Consultar um processo" },
  { id: "planilha", rotulo: "Preencher uma planilha" },
] as const;

type AbaId = (typeof ABAS)[number]["id"];

export function App() {
  const [aba, setAba] = useState<AbaId>("individual");

  return (
    <div className="pagina">
      <header className="cabecalho-app">
        <div className="cabecalho-conteudo">
          <div className="cabecalho-topo">
            <div className="marca-simbolo" aria-hidden="true">
              CP
            </div>
            <div>
              <h1 className="cabecalho-titulo">Consulta de Processos</h1>
              <p className="cabecalho-subtitulo">
                Metadados processuais da API Pública do DataJud — Conselho Nacional de Justiça
              </p>
            </div>
          </div>

          <div className="abas" role="tablist" aria-label="Seções">
            {ABAS.map((a) => (
              <button
                type="button"
                key={a.id}
                role="tab"
                id={`aba-${a.id}`}
                aria-selected={aba === a.id}
                aria-controls={`painel-${a.id}`}
                className="aba"
                onClick={() => setAba(a.id)}
              >
                {a.rotulo}
              </button>
            ))}
          </div>
        </div>
      </header>

      <main className="conteudo">
        {ABAS.map((a) => (
          <div
            key={a.id}
            role="tabpanel"
            id={`painel-${a.id}`}
            aria-labelledby={`aba-${a.id}`}
            hidden={aba !== a.id}
          >
            {aba === a.id &&
              (a.id === "individual" ? (
                <ConsultaIndividual />
              ) : (
                <Suspense fallback={<p className="dica">Carregando o leitor de planilhas…</p>}>
                  <Planilha />
                </Suspense>
              ))}
          </div>
        ))}
      </main>

      <footer className="rodape">
        <div className="rodape-conteudo">
          Dados obtidos da{" "}
          <a href="https://datajud-wiki.cnj.jus.br/api-publica/acesso/" target="_blank" rel="noreferrer noopener">
            API Pública do DataJud
          </a>
          , que publica os metadados dos processos públicos do Judiciário brasileiro (Resolução CNJ nº 331/2020).
          A base não traz nomes das partes nem o inteiro teor dos documentos, e processos em segredo de justiça
          não são divulgados. As informações são atualizadas periodicamente pelos tribunais — para efeitos
          oficiais, consulte o sistema do tribunal competente.
        </div>
      </footer>
    </div>
  );
}
